import { useInitializeMixpanel } from "@lending/hooks/useInitializeMixpanel";
import { Institution } from "@lending/types";

interface LendingMixpanelProps {
  institution: Institution;
}

function LendingMixpanel({ institution }: LendingMixpanelProps) {
  useInitializeMixpanel(institution);

  return null;
}

export default LendingMixpanel;
